/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type JobInfo,
    JobInfoFromJSON,
    JobInfoToJSON,
} from '../models/JobInfo';
import {
    type PredictorInput,
    PredictorInputFromJSON,
    PredictorInputToJSON,
} from '../models/PredictorInput';
import {
    type Results,
    ResultsFromJSON,
    ResultsToJSON,
} from '../models/Results';
import {
    type SubmissionRequestWithEmail,
    SubmissionRequestWithEmailFromJSON,
    SubmissionRequestWithEmailToJSON,
} from '../models/SubmissionRequestWithEmail';
import {
    type ViewerAnnotations,
    ViewerAnnotationsFromJSON,
    ViewerAnnotationsToJSON,
} from '../models/ViewerAnnotations';
import {
    type VinaJobInfo,
    VinaJobInfoFromJSON,
    VinaJobInfoToJSON,
} from '../models/VinaJobInfo';

export interface InhibitorsTsvRequest {
    id: string;
    download?: boolean;
}

export interface JobInfoRequest {
    id: string;
}

export interface MutantLigandPosesRequest {
    id: string;
    zincId: string;
}

export interface MutantStructureRequest {
    id: string;
}

export interface PredictorInputRequest {
    id: string;
    validate?: boolean;
}

export interface RawZipRequest {
    id: string;
}

export interface ResultsRequest {
    id: string;
}

export interface SubmitRequest {
    submissionRequestWithEmail: SubmissionRequestWithEmail;
}

export interface ViewerRequest {
    id: string;
}

export interface VinaGetDesiredRunRequest {
    id: string;
}

export interface VinaJobInfoRequest {
    id: string;
}

export interface VinaSetDesiredRunRequest {
    id: string;
    value: boolean;
}

export interface WildTypeCytoplasmicStructureRequest {
    id: string;
}

export interface WildTypeLigandPosesRequest {
    id: string;
    zincId: string;
}

/**
 * 
 */
export class JobControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for inhibitorsTsv without sending the request
     */
    async inhibitorsTsvRequestOpts(requestParameters: InhibitorsTsvRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling inhibitorsTsv().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['download'] != null) {
            queryParameters['download'] = requestParameters['download'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/jobs/{id}/inhibitors.tsv`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async inhibitorsTsvRaw(requestParameters: InhibitorsTsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const requestOptions = await this.inhibitorsTsvRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async inhibitorsTsv(requestParameters: InhibitorsTsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.inhibitorsTsvRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for jobInfo without sending the request
     */
    async jobInfoRequestOpts(requestParameters: JobInfoRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling jobInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/jobs/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async jobInfoRaw(requestParameters: JobInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JobInfo>> {
        const requestOptions = await this.jobInfoRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JobInfoFromJSON(jsonValue));
    }

    /**
     */
    async jobInfo(requestParameters: JobInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JobInfo> {
        const response = await this.jobInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mutantLigandPoses without sending the request
     */
    async mutantLigandPosesRequestOpts(requestParameters: MutantLigandPosesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling mutantLigandPoses().'
            );
        }

        if (requestParameters['zincId'] == null) {
            throw new runtime.RequiredError(
                'zincId',
                'Required parameter "zincId" was null or undefined when calling mutantLigandPoses().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/jobs/{id}/viewer/mutant/ligandPoses/{zincId}.pdbqt`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{zincId}', encodeURIComponent(String(requestParameters['zincId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async mutantLigandPosesRaw(requestParameters: MutantLigandPosesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const requestOptions = await this.mutantLigandPosesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async mutantLigandPoses(requestParameters: MutantLigandPosesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.mutantLigandPosesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mutantStructure without sending the request
     */
    async mutantStructureRequestOpts(requestParameters: MutantStructureRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling mutantStructure().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/jobs/{id}/viewer/mutant/structure.pdb`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async mutantStructureRaw(requestParameters: MutantStructureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const requestOptions = await this.mutantStructureRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async mutantStructure(requestParameters: MutantStructureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.mutantStructureRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for predictorInput without sending the request
     */
    async predictorInputRequestOpts(requestParameters: PredictorInputRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling predictorInput().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['validate'] != null) {
            queryParameters['validate'] = requestParameters['validate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/jobs/{id}/predictorInput`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async predictorInputRaw(requestParameters: PredictorInputRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PredictorInput>> {
        const requestOptions = await this.predictorInputRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PredictorInputFromJSON(jsonValue));
    }

    /**
     */
    async predictorInput(requestParameters: PredictorInputRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PredictorInput> {
        const response = await this.predictorInputRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for rawZip without sending the request
     */
    async rawZipRequestOpts(requestParameters: RawZipRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rawZip().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/jobs/{id}/raw.zip`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async rawZipRaw(requestParameters: RawZipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const requestOptions = await this.rawZipRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async rawZip(requestParameters: RawZipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.rawZipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for results without sending the request
     */
    async resultsRequestOpts(requestParameters: ResultsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling results().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/jobs/{id}/results`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async resultsRaw(requestParameters: ResultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Results>> {
        const requestOptions = await this.resultsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultsFromJSON(jsonValue));
    }

    /**
     */
    async results(requestParameters: ResultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Results> {
        const response = await this.resultsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for submit without sending the request
     */
    async submitRequestOpts(requestParameters: SubmitRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['submissionRequestWithEmail'] == null) {
            throw new runtime.RequiredError(
                'submissionRequestWithEmail',
                'Required parameter "submissionRequestWithEmail" was null or undefined when calling submit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/jobs`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubmissionRequestWithEmailToJSON(requestParameters['submissionRequestWithEmail']),
        };
    }

    /**
     */
    async submitRaw(requestParameters: SubmitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.submitRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async submit(requestParameters: SubmitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.submitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for viewer without sending the request
     */
    async viewerRequestOpts(requestParameters: ViewerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling viewer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/jobs/{id}/viewer`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async viewerRaw(requestParameters: ViewerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ViewerAnnotations>> {
        const requestOptions = await this.viewerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ViewerAnnotationsFromJSON(jsonValue));
    }

    /**
     */
    async viewer(requestParameters: ViewerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ViewerAnnotations> {
        const response = await this.viewerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vinaGetDesiredRun without sending the request
     */
    async vinaGetDesiredRunRequestOpts(requestParameters: VinaGetDesiredRunRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling vinaGetDesiredRun().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/jobs/{id}/vina/desiredRun`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async vinaGetDesiredRunRaw(requestParameters: VinaGetDesiredRunRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const requestOptions = await this.vinaGetDesiredRunRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async vinaGetDesiredRun(requestParameters: VinaGetDesiredRunRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.vinaGetDesiredRunRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vinaJobInfo without sending the request
     */
    async vinaJobInfoRequestOpts(requestParameters: VinaJobInfoRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling vinaJobInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/jobs/{id}/vina`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async vinaJobInfoRaw(requestParameters: VinaJobInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VinaJobInfo>> {
        const requestOptions = await this.vinaJobInfoRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VinaJobInfoFromJSON(jsonValue));
    }

    /**
     */
    async vinaJobInfo(requestParameters: VinaJobInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VinaJobInfo> {
        const response = await this.vinaJobInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vinaSetDesiredRun without sending the request
     */
    async vinaSetDesiredRunRequestOpts(requestParameters: VinaSetDesiredRunRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling vinaSetDesiredRun().'
            );
        }

        if (requestParameters['value'] == null) {
            throw new runtime.RequiredError(
                'value',
                'Required parameter "value" was null or undefined when calling vinaSetDesiredRun().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['value'] != null) {
            queryParameters['value'] = requestParameters['value'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/jobs/{id}/vina/desiredRun`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async vinaSetDesiredRunRaw(requestParameters: VinaSetDesiredRunRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.vinaSetDesiredRunRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async vinaSetDesiredRun(requestParameters: VinaSetDesiredRunRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.vinaSetDesiredRunRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for wildTypeCytoplasmicStructure without sending the request
     */
    async wildTypeCytoplasmicStructureRequestOpts(requestParameters: WildTypeCytoplasmicStructureRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling wildTypeCytoplasmicStructure().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/jobs/{id}/viewer/wildType/cytoplasmic.pdb`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async wildTypeCytoplasmicStructureRaw(requestParameters: WildTypeCytoplasmicStructureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const requestOptions = await this.wildTypeCytoplasmicStructureRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async wildTypeCytoplasmicStructure(requestParameters: WildTypeCytoplasmicStructureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.wildTypeCytoplasmicStructureRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for wildTypeLigandPoses without sending the request
     */
    async wildTypeLigandPosesRequestOpts(requestParameters: WildTypeLigandPosesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling wildTypeLigandPoses().'
            );
        }

        if (requestParameters['zincId'] == null) {
            throw new runtime.RequiredError(
                'zincId',
                'Required parameter "zincId" was null or undefined when calling wildTypeLigandPoses().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/jobs/{id}/viewer/wildType/ligandPoses/{zincId}.pdbqt`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{zincId}', encodeURIComponent(String(requestParameters['zincId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async wildTypeLigandPosesRaw(requestParameters: WildTypeLigandPosesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const requestOptions = await this.wildTypeLigandPosesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async wildTypeLigandPoses(requestParameters: WildTypeLigandPosesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.wildTypeLigandPosesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
